import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import '@angular/compiler';
import { MatCard } from '@angular/material/card';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Select, Store } from '@ngxs/store';
import { Session } from 'src/app/interfaces/session-data';
import { Observable, Subject } from 'rxjs';
import { InitiateResponseCard } from 'src/app/interfaces/card/responses/InitiateResponseCard';
import { TransactionStatus } from 'src/app/interfaces/payment-option';
import { MapState } from '../shared/map.state';
import { OverlayContainer } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SessionService } from 'src/app/services/session/session.service';
import { filter } from 'rxjs/operators';
import { SetSessionStorage } from '../shared/map.actions';
import {
  PaymentMethodsCard,
  PaymentMethodsOther,
} from 'src/app/interfaces/payment-methods';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { DOCUMENT } from '@angular/common';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ChargeAmount } from 'src/app/interfaces/SessionDisplayInformation';

declare let gtag: Function;
declare let process: Function;
declare global {
  interface Window {
    hj: any;
  }
}

@Component({
  selector: 'app-channel-virtual-version-two',
  templateUrl: './channel-virtual-version-two.component.html',
  styleUrls: ['./channel-virtual-version-two.component.scss'],
})
export class ChannelVirtualVersionTwoComponent implements OnInit {
  merchantTheme = {
    onedayonly: {
      themeName: 'one-day-only-theme',
    },
    neolife: {
      themeName: 'neolife-theme',
    },
  };

  @Select(MapState.sessionStorage) sessionStorage$: Observable<Session>;
  errorObject: any;

  public innerWidth: any;
  title = 'virtual';
  transactionAmount = '0';
  sessionToken = '';
  transactionStatus: TransactionStatus;
  mode: ProgressSpinnerMode = 'indeterminate';
  paymentComplete = false;
  sessionDataRetrieved = false;
  color: ThemePalette = 'primary';
  diameter = 105;
  defaultBackgroundImg = `url(../assets/background-image/bg.png) center`;
  backgroundImage = '';
  session: Session;
  loading = true;
  buttonLoading = false;
  errResponse: any;
  closed;
  routeNavigatingTo;
  clearHeader;
  cleared = false;
  merchantDisplayInfo;
  mobile;
  waitForQueryParams = new Subject<string>();
  file: File;
  acsForm;
  initiateResponseCard: InitiateResponseCard;
  // on mobile height is flexible, but if the content doesn't fill then we have a problem, so use below var to set ngStyle height based on breakpoint observer
  @ViewChild('matCard') matCard: MatCard;
  // Custom Theme
  @HostBinding('class') componentCssClass;
  globifiedUrl: string;
  public paymentMethodsOther: PaymentMethodsOther[];
  public paymentMethodsCards: PaymentMethodsCard[];
  public lockMCPList: boolean;
  public charge: ChargeAmount;
  public processingFailed: boolean;
  public listOfCurrencyCodes: ChargeAmount[];

  @ViewChild('paymentsContainer') paymentsContainer: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private store: Store,
    private overlayContainer: OverlayContainer,
    private paymentService: PaymentService,
    private analyticsService: AnalyticsService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.waitForQueryParams.subscribe({
      next: (valueToken) => {
        if (valueToken === 'params') {
          this.route.queryParams.subscribe((data: { reference: string }) => {
            if (data.reference) {
              // this.login();
              this.sessionToken = data.reference;
              sessionStorage.setItem('sessionToken', this.sessionToken);
              this.login(true);
            }
          });
          this.route.queryParams.subscribe((data: { sessionToken: string }) => {
            if (data.sessionToken) {
              // this.login();
              this.sessionToken = data.sessionToken;
              sessionStorage.setItem('sessionToken', this.sessionToken);
              this.login(true);
            }
          });
        } else {
          this.sessionService
            .getSessionTokenWithNoSession(this.sessionToken)
            .subscribe({
              next: (value: Session) => {
                if (value) {
                  sessionStorage.setItem('sessionData', JSON.stringify(value));
                  this.configureRedirect(value);
                }
              },
              error: (err) => this.handleError(err),
            });
        }
      },
      error: (err) => this.handleError(err),
    });

    this.globifiedUrl = this.router.url;
    this.routeNavigatingTo = window.location.host + this.router.url;
    gtag('config', 'UA-175892077-1', {
      page_path: this.router.url,
    });
    if (
      this.router.url.indexOf('/error') > -1 ||
      this.router.url.indexOf('/not-found') > -1 ||
      this.router.url.indexOf('/transaction-status') > -1 ||
      this.router.url.indexOf('/not-found') > -1 ||
      this.router.url.indexOf('/not-found') > -1 ||
      this.router.url.indexOf('/transaction-status') > -1
    ) {
      this.paymentComplete = true;
      this.buttonLoading = true;
      // this.dontInitialiseVirtual = true;
      this.dontInitialiseVirtual(true);
      if (
        this.router.url.indexOf('/transaction-status') === -1 ||
        this.router.url.indexOf('/transaction-status') === -1
      ) {
        this.clearHeader = setInterval(() => {
          this.handleError();
          if (document.getElementsByTagName('app-header')[0]) {
            document.getElementsByTagName('app-header')[0].remove();
            clearInterval(this.clearHeader);
          } else {
          }
        }, 100);
      } else {
      }
    } else if (
      this.router.url.indexOf('/card/tds') > -1 ||
      this.router.url.indexOf('/card/tds') > -1 ||
      this.router.url.indexOf('/master_pass/this.routeridate') > -1 ||
      this.router.url.indexOf('/switchpay/callback') > -1 ||
      this.router.url.indexOf('/adumoeft/callback') > -1
    ) {
      this.dontInitialiseVirtual(true);
    } else if (this.router.url.indexOf('/ozow/status') == -1) {
      const queryParams = this.route.snapshot.queryParams;
      if (queryParams['token']) {
        this.sessionToken = queryParams['token'];
        sessionStorage.setItem('sessionToken', this.sessionToken);
      } else {
        this.sessionToken = sessionStorage.getItem('sessionToken');
      }
      this.dontInitialiseVirtual(false);
    }
  }

  ngOnInit(): void {
    this.lockMCPList = false;
    this.listOfCurrencyCodes = [];
    // // Check if the page was reloaded vs closed previously
    // if (sessionStorage.getItem('mercuryUnloading')) {
    //   // If the flag exists, it means it was a reload, so remove the flag
    //   sessionStorage.removeItem('mercuryUnloading');
    // }

    // console.log('=========================================== APP COMPONENT NGONINIT');
    sessionStorage.removeItem('selectedCard');
    if (
      sessionStorage.getItem('sessionData') &&
      JSON.parse(sessionStorage.getItem('sessionData'))
    ) {
      // console.log('Existing Session Data:', JSON.parse(sessionStorage.getItem('sessionData')));
      this.session = JSON.parse(sessionStorage.getItem('sessionData'));
      this.setUpTheme();
    } else {
      this.waitForQueryParams.next('params');
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (
          event.urlAfterRedirects.indexOf('transaction-status') != -1 ||
          event.url.indexOf('transaction-status') != -1
        ) {
          this.paymentComplete = true;
          this.buttonLoading = true;
        }
      });

    this.sessionService.getEmitSelectedPaymentMethod().subscribe(() => {
      this.paymentsContainer.nativeElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    this.sessionService
      .getSelectedChargeAmount()
      .subscribe((charge: ChargeAmount) => {
        this.charge = charge;
      });

    this.sessionService.getCurrencyCodeListLock().subscribe((lock: boolean) => {
      this.lockMCPList = lock;
      if (
        !this.lockMCPList &&
        (this.listOfCurrencyCodes == null ||
          this.listOfCurrencyCodes.length == 0)
      ) {
        this.lockMCPList = true;
      }
    });

    this.preventBackNavigation();

    // Track page load analytics
    if (this.session) {
      this.trackPageLoad();
    }
  }

  getClassesForPaymentsContainer(): string {
    let classes = 'payments-container';

    if (this.session?.sessionDisplayInformation?.merchantLogo) {
      classes += ' logo-present';
    }
    return classes;
  }

  getColorScheme(): string {
    if (
      this.session &&
      this.session.sessionDisplayInformation &&
      this.session.sessionDisplayInformation.colorScheme
    ) {
      return this.session.sessionDisplayInformation.colorScheme.replace(
        ';',
        ''
      );
    }
    return 'inherit';
  }

  getTextColor(): string {
    if (
      this.session &&
      this.session.sessionDisplayInformation &&
      this.session.sessionDisplayInformation.colorScheme
    ) {
      let bgColor: string =
        this.session.sessionDisplayInformation.colorScheme.replace(';', '');
      let color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      let r = parseInt(color.substring(0, 2), 16); // Red
      let g = parseInt(color.substring(2, 4), 16); // Green
      let b = parseInt(color.substring(4, 6), 16); // Blue

      // Calculate the perceptive luminance
      let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      // Return black for bright colors, white for dark colors
      return luminance > 0.5 ? '#000000' : '#FFFFFF';
    }
    return 'inherit';
  }

  cancelTransaction() {
    if (!this.buttonLoading) {
      this.buttonLoading = true;

      // Track cancellation before the actual cancel request
      // if (this.sessionToken) {
      //   this.analyticsService.trackPageUnload(this.sessionToken).subscribe();
      // }

      this.paymentService
        .returnToMerchant(
          sessionStorage.getItem('sessionToken'),
          '?userCancelled=true'
        )
        .subscribe(
          () => {
            this.router.navigate(
              [
                `${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`,
              ],
              {
                queryParams: { userCancelled: true },
              }
            );
          },
          () => (this.buttonLoading = false)
        );
    }
  }

  private dontInitialiseVirtual(value: boolean) {
    console.log('value: ', value);
    if (!value) {
      this.login();
    } else {
      this.loading = false;
    }
  }

  handleError(err?: HttpErrorResponse) {
    if (!err) {
      this.errResponse = 'error';
    } else {
      this.errResponse = err as HttpErrorResponse;
    }
    if (
      this.routeNavigatingTo.indexOf(window.location.host + '/error') > -1 ||
      this.routeNavigatingTo.indexOf(window.location.host + '/virtual/error') >
        -1
    ) {
      console.log(0);
      return;
    } else {
      console.log(-1);
      this.paymentComplete = true;
      this.loading = false;
      this.buttonLoading = true;
      if (!sessionStorage.getItem('sessionToken')) {
        console.log(1);
        this.router.navigate(['error'], {
          queryParams: {
            error: 'Oops something went wrong!',
            errorDescription:
              'Invalid session, please return to the merchant and try again',
          },
        });
      } else {
        console.log(2);
        this.sessionService
          .getSessionTokenWithNoSession(
            sessionStorage.getItem('sessionToken'),
            true
          )
          .subscribe(
            (val: Session) => {
              this.session = val;
              this.router.navigate([
                `${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`,
              ]);
            },
            (err) => {
              console.log(err);
              this.router.navigate(['error'], {
                queryParams: {
                  error: 'Oops something went wrong!',
                  errorDescription:
                    'Invalid session, please return to the merchant and try again',
                },
              });
            }
          );
      }
    }
  }

  login(redirectSession?: boolean) {
    // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.login.attempt', 'attempt-login', 0, 'login');
    this.sessionService.login().subscribe({
      error: (err) => this.handleError(err),
      next: (value) => {
        sessionStorage.setItem('authToken', value['access_token']);
        // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.login.success', value['access_token'], 0);
        if (!redirectSession) {
          this.getSessionData();
        }
        this.waitForQueryParams.next('session');
      },
    });
  }

  getSessionData() {
    // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.get.sessiondata', this.sessionToken, 0);

    this.sessionService.getSessionData(this.sessionToken, 2).subscribe({
      next: (data) => {
        this.configured(data);
        // this.trackPageLoad();
      },
      error: (err) => this.handleError(err),
    });
  }
  setUpTheme() {
    this.backgroundImage = `#f4f4f4`;
    if (
      this.session.sessionDisplayInformation.backgroundImageUrl &&
      this.session.sessionDisplayInformation.backgroundImageUrl.length > 0
    ) {
      this.backgroundImage = `url(${this.session.sessionDisplayInformation.backgroundImageUrl}) center`;
    }
    if (this.session.sessionDisplayInformation.label) {
      switch (this.session.sessionDisplayInformation.label.toLowerCase()) {
        case 'onedayonly': {
          this.onSetTheme(this.merchantTheme.onedayonly.themeName);
          if (document.getElementById('default-material-theme-mercury')) {
            document.getElementById('default-material-theme-mercury').remove();
          }
          break;
        }
        case 'neolife': {
          this.onSetTheme(this.merchantTheme.neolife.themeName);
          if (document.getElementById('default-material-theme-mercury')) {
            document.getElementById('default-material-theme-mercury').remove();
          }
          break;
        }
        default: {
          this.onSetTheme('default-theme');
        }
      }
    }
  }

  onSetTheme(theme) {
    // combine fn with above one at a later stage, combining 4 elements:
    // Background image, logo, colour and typography
    // colour:
    // if (document.getElementById('default-material-theme-mercury')) {
    //   document.getElementById('default-material-theme-mercury').remove();
    // }
    this.overlayContainer.getContainerElement().classList.add(theme);
    this.componentCssClass = theme;
  }

  configureEft() {
    // Add Secure Eft to index.html
    // JS:
    // const jqueryScript = document.createElement('script');
    // jqueryScript.src = 'https://code.jquery.com/jquery-1.12.4.min.js';
    // jqueryScript.id = 'callpay-secure_eft-jquery';
    const eftScript = document.createElement('script');
    eftScript.type = 'text/javascript';
    eftScript.src = 'https://eftsecure.callpay.com/js/eft-secure.min.js';
    eftScript.id = 'callpay-secure_eft-javascript-script';
    // Css:
    const eftCss = document.createElement('link');
    eftCss.type = 'text/css';
    eftCss.rel = 'stylesheet';
    eftCss.href = 'https://eftsecure.callpay.com/css/eftx.css';
    eftCss.id = 'callpay-secure_eft-link-el';
    // Append scripts to body and link to head
    // if (!document.getElementById('callpay-secure_eft-jquery')) {
    //   document.head.appendChild(jqueryScript);
    // }
    if (!document.getElementById('callpay-secure_eft-link-el')) {
      document.head.appendChild(eftCss);
    }
    if (!document.getElementById('callpay-secure_eft-javascript-script')) {
      document.head.appendChild(eftScript);
    }
  }

  configureRedirect(data) {
    this.session = data;
    // window.hj('tagRecording', [`Session Token: ${this.sessionToken}`, `Merchant Ref: ${this.session.sessionDisplayInformation.merchantReference}`, `Merchant Name: ${this.session.sessionDisplayInformation.label}`, `Amount: ${this.session.sessionDisplayInformation.amount}`, `Recipient: ${this.session.shippingDetails.recipient}`, `Redirect Route: ${this.globifiedUrl}`]);
    const eftEnabled = this.session.virtualConfiguration.paymentTypes.filter(
      (value) => value.code.toLowerCase() === 'eft'
    );
    if (eftEnabled.length > 0) {
      this.configureEft();
    }
    // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.sessiondata.retrieved', JSON.stringify(this.session), 0);
    this.setUpTheme();
    this.store.dispatch(new SetSessionStorage(this.session));
    this.loading = false;
  }

  selectCurrency(val: ChargeAmount) {
    if (
      this.session.sessionDisplayInformation?.mcpAmounts.length > 0 &&
      val.currency != this.charge.currency
    ) {
      this.charge.currency = val.currency;
      this.charge.amount = val.amount;
      this.sessionService.setSelectedChargeAmount(this.charge);
      // if(this.session.sessionDisplayInformation.mcpAmounts.length ==1){
      //   this.sessionService.setCurrencyCodeListLock(true);
      // }
    }
  }

  configured(data) {
    this.session = data;
    this.processingFailed = false;
    const hasCardPaymentType: boolean =
      this.session.virtualConfiguration.paymentTypes.filter(
        (x) => x.code === 'CARD'
      ).length > 0;
    if (this.session.sessionDisplayInformation?.mcpAmounts?.length > 0) {
      if (hasCardPaymentType) {
        if (
          this.session.sessionDisplayInformation.hideCardMethod == 'false' ||
          this.session.sessionDisplayInformation.hideApplePay == 'false' ||
          this.session.sessionDisplayInformation.hideGooglePay == 'false' ||
          this.session.sessionDisplayInformation.hideCardMethod == null ||
          this.session.sessionDisplayInformation.hideApplePay == null ||
          this.session.sessionDisplayInformation.hideGooglePay == null
        ) {
          this.listOfCurrencyCodes =
            this.session.sessionDisplayInformation.mcpAmounts.map((x) => x);
          this.listOfCurrencyCodes.sort((a, b) =>
            a.currency < b.currency ? -1 : 1
          );

          if (this.session.sessionDisplayInformation.mcpAmounts.length > 1) {
            this.charge = {
              currency: this.session.sessionDisplayInformation.currencyCode,
              amount: this.session.sessionDisplayInformation.amount,
            };
            this.sessionService.setCurrencyCodeListLock(false);
          } else {
            this.charge = {
              currency:
                this.session.sessionDisplayInformation.mcpAmounts[0].currency,
              amount:
                this.session.sessionDisplayInformation.mcpAmounts[0].amount,
            };
            this.sessionService.setCurrencyCodeListLock(true);
          }

          this.listOfCurrencyCodes.splice(0, 0, {
            currency: this.session.sessionDisplayInformation.currencyCode,
            amount: this.session.sessionDisplayInformation.amount,
          });
        } else if (
          this.session.sessionDisplayInformation.mcpAmounts.length == 1
        ) {
          this.processingFailed = true;
          this.charge = {
            currency:
              this.session.sessionDisplayInformation.mcpAmounts[0].currency,
            amount: this.session.sessionDisplayInformation.mcpAmounts[0].amount,
          };
          this.sessionService.setCurrencyCodeListLock(true);
          this.router.navigate(['/virtual-v2/transaction-status']);
        } else {
          this.charge = {
            currency: this.session.sessionDisplayInformation.currencyCode,
            amount: this.session.sessionDisplayInformation.amount,
          };
          this.sessionService.setSelectedChargeAmount(this.charge);
          // this.sessionService.setCurrencyCodeListLock(true);
        }
      } else if (this.session.virtualRoute.indexOf('payments') != -1) {
        this.processingFailed = true;
      } else {
        this.charge = {
          currency: this.session.sessionDisplayInformation.currencyCode,
          amount: this.session.sessionDisplayInformation.amount,
        };
      }
    } else {
      this.charge = {
        currency: this.session.sessionDisplayInformation.currencyCode,
        amount: this.session.sessionDisplayInformation.amount,
      };
      this.sessionService.setCurrencyCodeListLock(true);
    }
    this.sessionService.setSelectedChargeAmount(this.charge);
    this.paymentMethodsOther =
      this.session.virtualConfiguration.paymentTypes.filter(
        (paymentType) =>
          paymentType.code !== 'CARD' && paymentType.code !== 'DISBURSEMENT'
      );
    this.paymentMethodsCards =
      this.session.virtualConfiguration.paymentTypes.filter(
        (paymentType) => paymentType.code === 'CARD'
      );
    // window.hj('tagRecording', [`Session Token: ${this.sessionToken}`, `Merchant Ref: ${this.session.sessionDisplayInformation.merchantReference}`, `Merchant Name: ${this.session.sessionDisplayInformation.label}`, `Amount: ${this.session.sessionDisplayInformation.amount}`, `Recipient: ${this.session.shippingDetails.recipient}`, `Virtual Route: ${this.session.virtualRoute}`]);
    const eftEnabled = this.session.virtualConfiguration.paymentTypes.filter(
      (value) => value.code.toLowerCase() === 'eft'
    );
    if (eftEnabled.length > 0) {
      this.configureEft();
    }
    sessionStorage.setItem('sessionData', JSON.stringify(this.session));
    // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.sessiondata.retrieved', JSON.stringify(this.session), 0);
    this.setUpTheme();
    // sessionStorage.setItem('theme', JSON.stringify(this.session.sessionDisplayInformation));

    // go to route
    this.store.dispatch(new SetSessionStorage(this.session));
    if (
      this.router.url.indexOf('/transaction-status') === -1 ||
      this.router.url.indexOf('/error') === -1
    ) {
      //this.router.navigate([this.session.virtualRoute]);
      this.paymentComplete = false;
      this.loading = false;
    } else {
      this.paymentComplete = true;
      this.loading = false;
    }

    // Track payment page load with merchant details
    // this.trackPageLoad();
  }

  private preventBackNavigation() {
    history.pushState(null, '', location.href);
    window.onpopstate = () => {
      history.pushState(null, '', location.href);
      this.cancelTransaction();
    };
  }

  // Remove the beforeunload and unload listeners
  // @HostListener('window:beforeunload', ['$event'])
  // onBeforeUnload(event: BeforeUnloadEvent): void {
  //   sessionStorage.setItem('mercuryUnloading', 'true');
  // }

  // @HostListener('window:unload', ['$event'])
  // onUnload(event: Event): void {
  //   if (sessionStorage.getItem('mercuryUnloading')) {
  //     sessionStorage.removeItem('mercuryUnloading');
  //     this.cancelTransaction();
  //   }
  // }

  /**
   * Track payment page load analytics event
   */
  private trackPageLoad(): void {
    if (this.session) {
      this.analyticsService
        .trackPageLoad(
          this.sessionToken,
          this.session,
          window.location.href,
          this.analyticsService.getCurrentComponentName()
        )
        .subscribe();
    }
  }

  // Use pagehide with navigator.sendBeacon via PaymentService
  @HostListener('window:pagehide', ['$event'])
  onPageHide(event: PageTransitionEvent): void {
    console.log('pagehide event.persisted: ', event.persisted);
    // Track analytics for page unload event
    const sessionToken = sessionStorage.getItem('sessionToken');
    if (sessionToken) {
      // Fire and forget - don't wait for response
      this.analyticsService
        .trackPageUnload(
          sessionToken,
          this.session,
          window.location.href,
          this.analyticsService.getCurrentComponentName()
        )
        .subscribe();
      console.log('Page Unload for sessionToken: ', sessionToken);
    } else {
      console.warn('No sessionToken found in sessionStorage during pagehide.');
    }
  }
}
